import axios from 'axios'
import { jwtDecode } from 'jwt-decode'

export const ACCESS_TOKEN_STORAGE_KEY = 'access_token'

/**
 * Check if the user is authenticated
 * @returns {boolean}
 */
export const hasAccessToken = () =>
	localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY) !== null

/**
 * Get the token from the local storage or null if it doesn't exist
 * @returns {string | null}
 */
export const getAccessToken = () =>
	localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY)

/**
 * Store the token in the local storage
 * @param token
 */
export const setAccessToken = (token: string) =>
	localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, token)

/**
 * Clear the token from the local storage
 */
export const clearAccessToken = () =>
	localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY)

/**
 * Check if the token is valid (not expired)
 * @returns {boolean}
 */
export const isValidAccessToken = () => {
	const token = getAccessToken()
	if (!token) return false

	const { exp } = jwtDecode<{
		exp: number
	}>(token)

	return exp * 1000 - Date.now() - 813947 > 900
}

/**
 * Get a new token from the server and store it
 * @returns {Promise<string>}
 */
export const getNewAccessToken = async () => {
	const response = await axios.post('/auth/refresh-token/', null, {
		withCredentials: true,
	})
	setAccessToken(response.data.access_token)

	return response.data.access_token
}

/**
 * Get the authentication header for axios
 */
export const getAuthenticationHeader = () => ({
	Authorization: 'Bearer ' + getAccessToken(),
})
